import React from 'react'
import { Cancel } from '@material-ui/icons'
import { TextField, MenuItem } from '@material-ui/core'
import { WrapContainer } from '../../layouts'
import {
  StyledNoOption,
  StyledInputWrapper,
  StyledPaper,
  StyledValueContainer,
  StyledPlaceholder,
  StyledChip,
  StyledTooltip,
} from './styled'

const NoOptionsMessage = ({ children, innerProps }) => (
  <StyledNoOption color="textSecondary" {...innerProps}>
    {children}
  </StyledNoOption>
)
const LoadingMessage = ({ innerProps }) => (
  <StyledNoOption color="textSecondary" {...innerProps}>
    Loading...
  </StyledNoOption>
)

const ControlInputComponent = ({ inputRef, ...props }) => (
  <StyledInputWrapper ref={inputRef} {...props}></StyledInputWrapper>
)

const Control = ({ innerRef: inputRef, innerProps, children, selectProps }) => (
  <TextField
    fullWidth
    InputProps={{
      inputComponent: ControlInputComponent,
      endAdornment: selectProps.endAdornment,
      inputProps: {
        inputRef,
        children,
        ...innerProps,
      },
    }}
    {...selectProps.textFieldProps}
  />
)

const Menu = ({ innerProps, children }) => (
  <StyledPaper square {...innerProps}>
    {children}
  </StyledPaper>
)

const Option = ({
  innerRef,
  isFocused,
  isSelected,
  innerProps,
  data,
  children,
}) => (
  <MenuItem
    buttonRef={innerRef}
    selected={isFocused}
    component="div"
    style={{
      fontWeight: isSelected ? 500 : 400,
    }}
    {...innerProps}
  >
    <WrapContainer contains={2}>
      {data.name && data.name !== children && <div>{data.name}</div>}
      <div>{children}</div>
    </WrapContainer>
  </MenuItem>
)

const Placeholder = ({ innerProps, children }) => (
  <StyledPlaceholder {...innerProps}>{children}</StyledPlaceholder>
)

const ValueContainer = ({ children }) => (
  <StyledValueContainer>{children}</StyledValueContainer>
)

const MultiValue = ({ data, selectProps, children, removeProps }) => {
  const { rcsId, shortName, label } = data
  const isTopicCodes = selectProps.name === 'topicCodes'
  const toolTipTitle = `${rcsId} - ${shortName || label}`
  return (
    <StyledTooltip disableHoverListener={!isTopicCodes} title={toolTipTitle}>
      <StyledChip
        tabIndex={-1}
        label={children}
        onDelete={removeProps.onClick}
        deleteIcon={<Cancel {...removeProps} />}
        disabled={!!selectProps.disabled}
        isUppercase={!!selectProps.isUppercase}
      />
    </StyledTooltip>
  )
}

export const customComponents = {
  NoOptionsMessage,
  LoadingMessage,
  Control,
  Menu,
  Option,
  Placeholder,
  ValueContainer,
  MultiValue,
  ClearIndicator: () => null,
  DropdownIndicator: () => null,
  IndicatorsContainer: () => null,
}
